export enum UIIndividualWarningStates {
  Address,
  Dob,
  BirthPlace
}
